module.exports = __webpack_public_path__ + "static/polygonid-d029a425e1b29211a7ba3186a8db66d5.png";